<template>
  <dl :class="{ small }">
    <slot />
  </dl>
</template>

<script>
/**
 * フォームグリッド
 *
 * `<dt>`,`<dd>`, `<hr>` を使用して、入力フォームの項目をグリッド表示します。
 */
export default {
  name: 'FormGrid',
  props: {
    /** 小型（ダイアログなど） */
    small: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
dl {
  display: grid;
  grid-gap: 16px 8px;
  grid-template-columns: 128px 1fr;
}

>>> dt {
  font-weight: 600;
  padding-top: 9px;

  &.table-select {
    padding-top: 0;
  }
}

>>> dd {
  align-items: center;
  display: grid;
  grid-gap: 8px;
  min-height: 40px;
}

>>> hr {
  border: none;
  border-top: 1px solid var(--border-color);
  grid-column: 1 / -1;
  margin: 16px 0;
}

.small {
  grid-gap: 24px 8px;
  grid-template-columns: auto 1fr;

  >>> dt {
    font-weight: normal;
    justify-self: end;
  }
}
</style>
